import { FileText, ListChecks, Search } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
  DEFAULT_INTEGRATIONS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: FileText,
    title: "Transcripción Automática",
    desc: "Convierte cada reunión en texto buscable y organizado.",
  },
  {
    Icon: ListChecks,
    title: "Resúmenes Inteligentes",
    desc: "Genera minutas y próximos pasos automáticamente al finalizar la llamada.",
  },
  {
    Icon: Search,
    title: "Búsqueda de Momentos Clave",
    desc: "Encuentra decisiones y compromisos específicos dentro de reuniones pasadas.",
  },
];

const MeetingAIPage = () => {
  useDocumentTitle("Caruna Meeting AI — Inteligencia en Reuniones");
  return (
    <ProductPage
      category="meeting-ai"
      eyebrow="INTELIGENCIA EN REUNIONES"
      headline="Caruna Meeting AI"
      subhead="Lleva la inteligencia artificial a cada reunión en Microsoft Teams."
      features={FEATURES}
      steps={DEFAULT_STEPS}
      integrations={DEFAULT_INTEGRATIONS}
      ctaHeadline="Solicita una evaluación técnica de Caruna Meeting AI"
      baseTech="Meeting Insights"
      heroBody="Caruna Meeting AI lleva la inteligencia artificial a cada reunión en Microsoft Teams: transcripción automática, resúmenes con próximos pasos y búsqueda semántica de momentos clave dentro de reuniones pasadas."
    />
  );
};

export default MeetingAIPage;
